"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitcoinRelay = void 0;
const abis_1 = require("../../abis");
const contract_base_1 = __importDefault(require("../contract-base"));
class BitcoinRelay extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, abis_1.BitcoinRelayABI);
    }
    firstSubmittedHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            const firstSubmittedHeight = yield this.contract.methods.initialHeight().call();
            return firstSubmittedHeight.toString();
        });
    }
    isBlockHashSubmitted(blockHash, blockHeight) {
        return __awaiter(this, void 0, void 0, function* () {
            const BlockHashWith0x = `0x${Buffer.from(blockHash, "hex").reverse().toString("hex")}`;
            const numberOfSubmittedHeaders = yield this.getNumberOfSubmittedHeaders(blockHeight);
            for (let i = 0; i < numberOfSubmittedHeaders; i += 1) {
                const submittedBlockHeaderHash = yield this.getSubmittedHeaderHash(blockHeight, i);
                if (BlockHashWith0x === submittedBlockHeaderHash) {
                    return true;
                }
            }
            return false;
        });
    }
    lastSubmittedHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            const lastSubmittedHeight = yield this.contract.methods.lastSubmittedHeight().call();
            return lastSubmittedHeight.toString();
        });
    }
    getNumberOfSubmittedHeaders(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const numberOfSubmittedHeaders = yield this.contract.methods
                .getNumberOfSubmittedHeaders(height)
                .call();
            return +numberOfSubmittedHeaders.toString();
        });
    }
    getSubmittedHeaderHash(height, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockHeaderHash = yield this.contract.methods.getBlockHeaderHash(height, index).call();
            return blockHeaderHash;
        });
    }
    getBlockHeaderFee(height, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockHeaderHash = yield this.contract.methods.getBlockHeaderFee(height, index).call();
            return blockHeaderHash;
        });
    }
    submitBlockHeadersWithRetarget(oldPeriodStartHeader, oldPeriodEndHeader, newBlockHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethod("addHeadersWithRetarget", "0", [
                oldPeriodStartHeader,
                oldPeriodEndHeader,
                newBlockHeaders,
            ]);
        });
    }
    submitBlockHeaders(anchorBlockHeader, newBlockHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethod("addHeaders", "0", [anchorBlockHeader, newBlockHeaders]);
        });
    }
    getNumberOfConfirmations() {
        return __awaiter(this, void 0, void 0, function* () {
            const finalizationParameter = yield this.contract.methods.finalizationParameter().call();
            return finalizationParameter.toString();
        });
    }
    getLastBlockFee() {
        return __awaiter(this, void 0, void 0, function* () {
            const blockHeight = yield this.lastSubmittedHeight();
            const numberOfSubmittedHeaders = yield this.getNumberOfSubmittedHeaders(+blockHeight);
            return this.getBlockHeaderFee(+blockHeight, +numberOfSubmittedHeaders - 1);
        });
    }
}
exports.BitcoinRelay = BitcoinRelay;
exports.default = BitcoinRelay;
//# sourceMappingURL=bitcoin-relay-contract-interface.js.map